"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const react_dom_1 = require("react-dom");
const Overlay = styled_components_1.default.div `
  background-color: rgba(30, 33, 32);
  opacity: 0.44;
  transition: opacity 0.4s ease;
  z-index: 999;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100vh;
  &[data-hidden="true"] {
    left: -100vh;
    opacity: 0;
  }
`;
const OverlayFC = ({ isHidden, onClick }) => {
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)(Overlay, { "data-hidden": isHidden, onClick: () => onClick && onClick() }, void 0), document.body);
};
exports.default = OverlayFC;
//# sourceMappingURL=Overlay.js.map